module.exports = __webpack_public_path__ + "mobile.svg?f6fb38a1e579816e7681bd8fd352e088";